export const GET_USERS = "GET_USERS"
export const SET_USERS = "SET_USERS"
export const GET_USER = "GET_USER"
export const SET_USER = "SET_USER"
export const SET_DOCTORS_STATE = "SET_DOCTORS_STATE"
export const UPDATE_USER = "UPDATE_USER"
export const SET_FILES = "SET_FILES"
export const GET_FILES = "GET_FILES"
